import React from 'react'

const Compliance = () => {
  return (
    <div>
        
    </div>
  )
}

export default Compliance